export const FONT_SIZES = ["xs", "sm", "md", "lg", "xl"];

export const FONT_SIZE_MAP = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
};